var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 37.5V26.25C30.5 22.2718 32.0804 18.4564 34.8934 15.6434C37.7064 12.8304 41.5218 11.25 45.5 11.25C49.4782 11.25 53.2936 12.8304 56.1066 15.6434C58.9196 18.4564 60.5 22.2718 60.5 26.25V37.5",
    stroke: "#22283A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 47C14.5 42.5817 18.0817 39 22.5 39H68.5C72.9183 39 76.5 42.5817 76.5 47V72.5455C76.5 74.5225 75.5668 76.4186 73.9058 77.8166C72.2448 79.2146 69.9919 80 67.6429 80H23.3571C21.0081 80 18.7552 79.2146 17.0942 77.8166C15.4332 76.4186 14.5 74.5225 14.5 72.5455V47Z",
    stroke: "#22283A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 60H58.5375V60.0375H58.5V60Z",
    stroke: "#22283A",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9c38b7f69fbf9729736b9699724ea6a3.svg";
export { ForwardRef as ReactComponent };